import { ReportType } from 'app/constants/reportType'

export const getReportTypeByNumber = (type: number) => {
  let reportType = ReportType.NONE

  switch (type) {
    case 9:
      reportType = ReportType.DRIVER_DAILY_ACTIVITIES
      break
    case 10:
      reportType = ReportType.DRIVER_WEEKLY_ACTIVITIES
      break
    case 8:
      reportType = ReportType.DRIVER_ACTIVITIES
      break
    case 23:
      reportType = ReportType.VIOLATIONS
      break
    case 24:
      reportType = ReportType.GROUPED_VIOLATIONS
      break
    case 1:
      reportType = ReportType.TIMESHEET
      break
    case 3:
      reportType = ReportType.TIMESHEET_AMOUNTS_REPORT
      break
    case 25:
      reportType = ReportType.TRIP_SUMMARY
      break
    case 26:
      reportType = ReportType.TRIP_DETAILS
      break
    case 30:
      reportType = ReportType.BASIC_TRIP_PRINT
      break
    case 117:
      reportType = ReportType.GROUPED_TRIP_BASICS
      break
    case 27:
      reportType = ReportType.TRIP_GENERAL_STATEMENT
      break
    case 2:
      reportType = ReportType.TIMESHEET_LUMPSUM_SETTLEMENT
      break
    case 54:
      reportType = ReportType.TIMESHEET_LUMPSUM_SETTLEMENT_SUMMARY
      break
    case 67:
      reportType = ReportType.DRIVER_AVAILABLE_TIME
      break
    case 39:
      reportType = ReportType.CARD_READING_DEADLINE
      break
    case 33:
      reportType = ReportType.DRIVER_INSTRUCTION
      break
    case 56:
      reportType = ReportType.TIMESHEET_EMPTY_DAYS
      break
    case 58:
      reportType = ReportType.TIMESHEET_SUMMARY
      break
    case 41:
      reportType = ReportType.DOCUMENT_VALIDITY_DEADLINE
      break
    case 51:
      reportType = ReportType.DRIVER_FAULTS_AND_EVENTS
      break
    case 36:
      reportType = ReportType.DRIVER_CARD_APPLICATION
      break
    case 38:
      reportType = ReportType.OUTGOING_CHECKLIST
      break
    case 34:
      reportType = ReportType.BUSINESS_TRIP_COMMAND
      break
    case 28:
      reportType = ReportType.TRIP_DEPOSIT_REQUEST
      break
    case 15:
      reportType = ReportType.DRIVER_DATA_COMPLETNESS
      break
    case 16:
      reportType = ReportType.DRIVER_ATTESTATION_REPORT
      break
    case 63:
      reportType = ReportType.TIMESHEET_APPLICATION_FOR_OVERHOURS_FOR_DRIVERS
      break
    case 59:
      reportType = ReportType.TIMESHEET_PERIOD_SUMMARY
      break
    case 7:
      reportType = ReportType.TIMESHEET_WORKING_HOURS
      break
    case 53:
      reportType = ReportType.DRIVER_FREE_DAYS
      break
    case 55:
      reportType = ReportType.TIMESHEET_OVERHOURS_SUMMARY
      break
    case 4:
      reportType = ReportType.TIMESHEET_FOREIGN_AMOUNT_SUMMARY
      break
    case 5:
      reportType = ReportType.TIMESHEET_FOREIGN_AMOUNTS_REPORT
      break
    case 6:
      reportType = ReportType.TIMESHEET_FOREIGN_AMOUNTS_FOR_DRIVER_REPORT
      break
    case 17:
      reportType = ReportType.DRIVER_DAY_DETAILS
      break
    case 91:
      reportType = ReportType.DRIVER_DAY_DETAILS_WITH_SIGNATURE_REPORT
      break
    case 29:
      reportType = ReportType.TRIP_FOREIGN_COUNTRY
      break
    case 42:
      reportType = ReportType.LOCALIZATION
      break
    case 60:
      reportType = ReportType.TIMESHEET_TIME_SUMMARY
      break
    case 13:
      reportType = ReportType.DRIVER_CALENDAR
      break
    case 57:
      reportType = ReportType.WEEKLY_RESTS
      break
    case 35:
      reportType = ReportType.SPECIFIC_BUSINESS_TRIP_COMMAND
      break
    case 31:
      reportType = ReportType.TRIP_INVOICES
      break
    case 46:
      reportType = ReportType.DRIVER_CARD_READING
      break
    case 69:
      reportType = ReportType.DRIVER_PERIOD_DISTANCE
      break
    case 65:
      reportType = ReportType.TIMESHEET_APPLICATION_FOR_LEAVE_FOR_DRIVERS
      break
    case 71:
      reportType = ReportType.TIMESHEET_YEAR_SUMMARY
      break
    case 70:
      reportType = ReportType.COMPANY_REPUTATION_INDEX
      break
    case 18:
      reportType = ReportType.VEHICLE_ACTIVITIES
      break
    case 44:
      reportType = ReportType.VEHICLE_CALIBRATION_DEADLINE
      break
    case 45:
      reportType = ReportType.VEHICLE_CARD_READING_AND_CALIBRATION_DEADLINE
      break
    case 43:
      reportType = ReportType.VEHICLE_CARD_READING_DEADLINE
      break
    case 22:
      reportType = ReportType.VEHICLE_DATA_COMPLETNESS
      break
    case 49:
      reportType = ReportType.VEHICLE_DAY_DETAILS
      break
    case 52:
      reportType = ReportType.VEHICLE_FAULTS_AND_EVENTS
      break
    case 21:
      reportType = ReportType.VEHICLE_CALENDAR
      break
    case 74:
      reportType = ReportType.DRIVER_ACTIVITY_SUMMARY
      break
    case 75:
      reportType = ReportType.MANAGER_REPORT_1
      break
    case 76:
      reportType = ReportType.MANAGER_REPORT_2
      break
    case 77:
      reportType = ReportType.MANAGER_REPORT_3
      break
    case 78:
      reportType = ReportType.TIMESHEET_DETAILED_WAGE_REPORT
      break
    case 72:
      reportType = ReportType.DATA_ACCESS_EVENTS
      break
    case 73:
      reportType = ReportType.DRIVERS_VIOLATIONS
      break
    case 79:
      reportType = ReportType.FOREIGN_COUNTRY_SERVICE_DECLARATIONS_DEADLINES
      break
    case 80:
      reportType = ReportType.FOREIGN_COUNTRY_DECLARATIONS_DEADLINES
      break
    case 81:
      reportType = ReportType.ACTIVITY_CHANGE_CONFIRMATION_REPORT
      break
    case 82:
      reportType = ReportType.VEHICLES_LIST
      break
    case 68:
      reportType = ReportType.DRIVERS_LIST
      break
    case 66:
      reportType = ReportType.DRIVER_APPLICATIONS
      break
    case 47:
      reportType = ReportType.ALL_ALERTS
      break
    case 48:
      reportType = ReportType.SELECTED_ALERTS
      break
    case 19:
      reportType = ReportType.VEHICLE_DAILY_ACTIVITIES
      break
    case 20:
      reportType = ReportType.VEHICLE_WEEKLY_ACTIVITIES
      break
    case 95:
      reportType = ReportType.MOBILITY_PACKAGE_PAYROL_REPORT
      break
    case 96:
      reportType = ReportType.REWARDS_TO_ACCEPT_REPORT
      break
    case 97:
      reportType = ReportType.SELECTED_TIMESHEET_MOBILITY_PACKAGE_PAYROLL_REPORT
      break
    case 98:
      reportType = ReportType.SELECTED_REWARDS_TO_ACCEPT_REPORT
      break
    case 61:
      reportType = ReportType.TIMESHEET_SCHEDULE
      break
    case 100:
      reportType = ReportType.TIMESHEET_LEAVES_CALCULATION
      break
    case 116:
      reportType = ReportType.TIMESHEET_LEAVE_EQUIVALENT_CALCULATION
      break
    case 102:
      reportType = ReportType.FOREIGN_ALLOWANCES
      break
    case 103:
      reportType = ReportType.TIMESHEET_PAYMENT_DETAILS
      break
    case 104:
      reportType = ReportType.TRIP_COSTS
      break
    case 105:
      reportType = ReportType.STATEMENT_ON_EMPLOYEES_COUNT
      break
    case 106:
      reportType = ReportType.DRIVER_YEAR_GROSS_AMOUNTS
      break
    case 107:
      reportType = ReportType.DECLARATION_NOT_RETURN_TO_PLACE_OF_RESIDENCE
      break
    case 108:
      reportType = ReportType.TIMESHEET_LUMPSUM_UTILIZATION
      break
    case 109:
      reportType = ReportType.WEEKLY_RESTS_WITH_LOCATION
      break
    case 110:
      reportType = ReportType.VIRTUAL_DISPLACEMENT
      break
    case 111:
      reportType = ReportType.TIMESHEET_CALCULATION_AUDIT
      break
    case 112:
      reportType = ReportType.DRIVER_CONTRACT_SUMMARY
      break
    case 113:
      reportType = ReportType.DRIVER_CONTRACT_ANNEX
      break
    case 114:
      reportType = ReportType.DRIVER_CONTRACT_ADAPTIVE
      break
    case 115:
      reportType = ReportType.NIGHT_WORK_DUTY_DELEGATIONS_REPORT
      break
    case 118:
      reportType = ReportType.DRIVER_CARDS
      break
    case 119:
      reportType = ReportType.TIMESHEET_LEAVE_DAYS_REPORT
      break
    case 120:
      reportType = ReportType.TIMESHEET_WORK_COSTS
      break
    case 121:
      reportType = ReportType.TIMESHEET_PAYMENT_REPORT
      break
    case 122:
      reportType = ReportType.DRIVER_WORKING_DAYS
      break
    case 127:
      reportType = ReportType.VEHICLE_CARD_INSERTION_WITHDRAWAL
      break
    case 84:
      reportType = ReportType.FREE_DAYS_SUMMARY_SERVICE_REPORT
      break
    case 85:
      reportType = ReportType.MINIMAL_PAYMENT_COUNTRY_HOURS_SERVICE_REPORT
      break
    case 86:
      reportType = ReportType.MINIMAL_PAYMENT_COUNTRY_AMOUNTS_SERVICE_REPORT
      break
    case 87:
      reportType = ReportType.TIMESHEET_HOURS_SERVICE_REPORT
      break
    case 88:
      reportType = ReportType.FOREIGN_TRIPS_SERVICE_REPORT
      break
    case 40:
      reportType = ReportType.CARD_READING_DEADLINE_SERVICE
      break
    case 101:
      reportType = ReportType.DRIVER_ACTIVENESS
      break
    case 129:
      reportType = ReportType.VEHICLE_TACHO_DETAILS
      break
    case 128:
      reportType = ReportType.VEHICLE_TACHOGRAPH_DEADLINE
      break
    case 126:
      reportType = ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL_SIMPLE
      break
    case 125:
      reportType = ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL
      break
    case 132:
      reportType = ReportType.TIMESHEET_FOREIGN_AMOUNTS_NEW_VERSION_REPORT
      break
    case 131:
      reportType = ReportType.DRIVER_CONTRACTS_FROM_PERIOD
      break
    case 124:
      reportType = ReportType.TIMESHEET_REWARD_FOR_DRIVERS
      break
    case 123:
      reportType = ReportType.DRIVER_COMPLETE_SETTLEMENT
      break
  }

  return reportType
}

export const getReportNumberByType = (type: ReportType) => {
  let reportNumber = 0

  switch (type) {
    case ReportType.DRIVER_ACTIVITIES:
      reportNumber = 8
      break
    case ReportType.DRIVER_DAILY_ACTIVITIES:
      reportNumber = 9
      break
    case ReportType.DRIVER_WEEKLY_ACTIVITIES:
      reportNumber = 10
      break
    case ReportType.VIOLATIONS:
      reportNumber = 23
      break
    case ReportType.GROUPED_VIOLATIONS:
      reportNumber = 24
      break
    case ReportType.TIMESHEET:
      reportNumber = 1
      break
    case ReportType.TIMESHEET_DETAILED_WAGE_REPORT:
      reportNumber = 78
      break
    case ReportType.TIMESHEET_AMOUNTS_REPORT:
      reportNumber = 3
      break
    case ReportType.TRIP_SUMMARY:
      reportNumber = 25
      break
    case ReportType.TRIP_DETAILS:
      reportNumber = 26
      break
    case ReportType.BASIC_TRIP_PRINT:
      reportNumber = 30
      break
    case ReportType.GROUPED_TRIP_BASICS:
      reportNumber = 117
      break
    case ReportType.TRIP_GENERAL_STATEMENT:
      reportNumber = 27
      break
    case ReportType.TIMESHEET_LUMPSUM_SETTLEMENT:
      reportNumber = 2
      break
    case ReportType.TIMESHEET_LUMPSUM_SETTLEMENT_SUMMARY:
      reportNumber = 54
      break
    case ReportType.DRIVER_AVAILABLE_TIME:
      reportNumber = 67
      break
    case ReportType.CARD_READING_DEADLINE:
      reportNumber = 39
      break
    case ReportType.DRIVER_INSTRUCTION:
      reportNumber = 33
      break
    case ReportType.TIMESHEET_EMPTY_DAYS:
      reportNumber = 56
      break
    case ReportType.TIMESHEET_SUMMARY:
      reportNumber = 58
      break
    case ReportType.DOCUMENT_VALIDITY_DEADLINE:
      reportNumber = 41
      break
    case ReportType.DRIVER_FAULTS_AND_EVENTS:
      reportNumber = 51
      break
    case ReportType.DRIVER_CARD_APPLICATION:
      reportNumber = 36
      break
    case ReportType.OUTGOING_CHECKLIST:
      reportNumber = 38
      break
    case ReportType.BUSINESS_TRIP_COMMAND:
      reportNumber = 34
      break
    case ReportType.TRIP_DEPOSIT_REQUEST:
      reportNumber = 28
      break
    case ReportType.DRIVER_DATA_COMPLETNESS:
      reportNumber = 15
      break
    case ReportType.DRIVER_ATTESTATION_REPORT:
      reportNumber = 16
      break
    case ReportType.TIMESHEET_APPLICATION_FOR_OVERHOURS_FOR_DRIVERS:
      reportNumber = 63
      break
    case ReportType.TIMESHEET_PERIOD_SUMMARY:
      reportNumber = 59
      break
    case ReportType.TIMESHEET_WORKING_HOURS:
      reportNumber = 7
      break
    case ReportType.DRIVER_FREE_DAYS:
      reportNumber = 53
      break
    case ReportType.TIMESHEET_OVERHOURS_SUMMARY:
      reportNumber = 55
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNT_SUMMARY:
      reportNumber = 4
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNTS_REPORT:
      reportNumber = 5
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNTS_FOR_DRIVER_REPORT:
      reportNumber = 6
      break
    case ReportType.DRIVER_DAY_DETAILS:
      reportNumber = 17
      break
    case ReportType.DRIVER_DAY_DETAILS_WITH_SIGNATURE_REPORT:
      reportNumber = 91
      break
    case ReportType.TRIP_FOREIGN_COUNTRY:
      reportNumber = 29
      break
    case ReportType.LOCALIZATION:
      reportNumber = 42
      break
    case ReportType.TIMESHEET_TIME_SUMMARY:
      reportNumber = 60
      break
    case ReportType.DRIVER_CALENDAR:
      reportNumber = 13
      break
    case ReportType.WEEKLY_RESTS:
      reportNumber = 57
      break
    case ReportType.SPECIFIC_BUSINESS_TRIP_COMMAND:
      reportNumber = 35
      break
    case ReportType.TRIP_INVOICES:
      reportNumber = 31
      break
    case ReportType.DRIVER_CARD_READING:
      reportNumber = 46
      break
    case ReportType.TIMESHEET_APPLICATION_FOR_LEAVE_FOR_DRIVERS:
      reportNumber = 65
      break
    case ReportType.DRIVER_PERIOD_DISTANCE:
      reportNumber = 69
      break
    case ReportType.COMPANY_REPUTATION_INDEX:
      reportNumber = 70
      break
    case ReportType.TIMESHEET_YEAR_SUMMARY:
      reportNumber = 71
      break
    case ReportType.VEHICLE_ACTIVITIES:
      reportNumber = 18
      break
    case ReportType.VEHICLE_CALIBRATION_DEADLINE:
      reportNumber = 44
      break
    case ReportType.VEHICLE_CARD_READING_AND_CALIBRATION_DEADLINE:
      reportNumber = 45
      break
    case ReportType.VEHICLE_CARD_READING_DEADLINE:
      reportNumber = 43
      break
    case ReportType.VEHICLE_DATA_COMPLETNESS:
      reportNumber = 22
      break
    case ReportType.VEHICLE_DAY_DETAILS:
      reportNumber = 49
      break
    case ReportType.VEHICLE_FAULTS_AND_EVENTS:
      reportNumber = 52
      break
    case ReportType.VEHICLE_CALENDAR:
      reportNumber = 21
      break
    case ReportType.DRIVER_ACTIVITY_SUMMARY:
      reportNumber = 74
      break
    case ReportType.MANAGER_REPORT_1:
      reportNumber = 75
      break
    case ReportType.MANAGER_REPORT_2:
      reportNumber = 76
      break
    case ReportType.MANAGER_REPORT_3:
      reportNumber = 77
      break
    case ReportType.DATA_ACCESS_EVENTS:
      reportNumber = 72
      break
    case ReportType.DRIVERS_VIOLATIONS:
      reportNumber = 73
      break
    case ReportType.FOREIGN_COUNTRY_SERVICE_DECLARATIONS_DEADLINES:
      reportNumber = 79
      break
    case ReportType.FOREIGN_COUNTRY_DECLARATIONS_DEADLINES:
      reportNumber = 80
      break
    case ReportType.ACTIVITY_CHANGE_CONFIRMATION_REPORT:
      reportNumber = 81
      break
    case ReportType.VEHICLES_LIST:
      reportNumber = 82
      break
    case ReportType.DRIVERS_LIST:
      reportNumber = 68
      break
    case ReportType.DRIVER_APPLICATIONS:
      reportNumber = 66
      break
    case ReportType.ALL_ALERTS:
      reportNumber = 47
      break
    case ReportType.SELECTED_ALERTS:
      reportNumber = 48
      break
    case ReportType.VEHICLE_DAILY_ACTIVITIES:
      reportNumber = 19
      break
    case ReportType.VEHICLE_WEEKLY_ACTIVITIES:
      reportNumber = 20
      break
    case ReportType.MOBILITY_PACKAGE_PAYROL_REPORT:
      reportNumber = 95
      break
    case ReportType.REWARDS_TO_ACCEPT_REPORT:
      reportNumber = 96
      break
    case ReportType.SELECTED_TIMESHEET_MOBILITY_PACKAGE_PAYROLL_REPORT:
      reportNumber = 97
      break
    case ReportType.SELECTED_REWARDS_TO_ACCEPT_REPORT:
      reportNumber = 98
      break
    case ReportType.TIMESHEET_SCHEDULE:
      reportNumber = 61
      break
    case ReportType.FOREIGN_ALLOWANCES:
      reportNumber = 102
      break
    case ReportType.TRIP_COSTS:
      reportNumber = 104
      break
    case ReportType.TIMESHEET_PAYMENT_DETAILS:
    case ReportType.TIMESHEET_PAYMENT_DETAILS_CSV:
      reportNumber = 103
      break
    case ReportType.STATEMENT_ON_EMPLOYEES_COUNT:
      reportNumber = 105
      break
    case ReportType.DRIVER_YEAR_GROSS_AMOUNTS:
      reportNumber = 106
      break
    case ReportType.DECLARATION_NOT_RETURN_TO_PLACE_OF_RESIDENCE:
      reportNumber = 107
      break
    case ReportType.TIMESHEET_LUMPSUM_UTILIZATION:
      reportNumber = 108
      break
    case ReportType.WEEKLY_RESTS_WITH_LOCATION:
      reportNumber = 109
      break
    case ReportType.VIRTUAL_DISPLACEMENT:
      reportNumber = 110
      break
    case ReportType.TIMESHEET_LEAVES_CALCULATION:
      reportNumber = 100
      break
    case ReportType.TIMESHEET_LEAVE_EQUIVALENT_CALCULATION:
      reportNumber = 116
      break
    case ReportType.TIMESHEET_CALCULATION_AUDIT:
      reportNumber = 111
      break
    case ReportType.DRIVER_CONTRACT_SUMMARY:
      reportNumber = 112
      break
    case ReportType.DRIVER_CONTRACT_ANNEX:
      reportNumber = 113
      break
    case ReportType.DRIVER_CONTRACT_ADAPTIVE:
      reportNumber = 114
      break
    case ReportType.NIGHT_WORK_DUTY_DELEGATIONS_REPORT:
      reportNumber = 115
      break
    case ReportType.DRIVER_CARDS:
      reportNumber = 118
      break
    case ReportType.TIMESHEET_LEAVE_DAYS_REPORT:
      reportNumber = 119
      break
    case ReportType.TIMESHEET_WORK_COSTS:
      reportNumber = 120
      break
    case ReportType.TIMESHEET_PAYMENT_REPORT:
      reportNumber = 121
      break
    case ReportType.DRIVER_WORKING_DAYS:
      reportNumber = 122
      break
    case ReportType.VEHICLE_CARD_INSERTION_WITHDRAWAL:
      reportNumber = 127
      break
    case ReportType.FREE_DAYS_SUMMARY_SERVICE_REPORT:
      reportNumber = 84
      break
    case ReportType.MINIMAL_PAYMENT_COUNTRY_HOURS_SERVICE_REPORT:
      reportNumber = 85
      break
    case ReportType.MINIMAL_PAYMENT_COUNTRY_AMOUNTS_SERVICE_REPORT:
      reportNumber = 86
      break
    case ReportType.TIMESHEET_HOURS_SERVICE_REPORT:
      reportNumber = 87
      break
    case ReportType.FOREIGN_TRIPS_SERVICE_REPORT:
      reportNumber = 88
      break
    case ReportType.CARD_READING_DEADLINE_SERVICE:
      reportNumber = 40
      break
    case ReportType.DRIVER_ACTIVENESS:
      reportNumber = 101
      break
    case ReportType.VEHICLE_TACHO_DETAILS:
      reportNumber = 129
      break
    case ReportType.VEHICLE_TACHOGRAPH_DEADLINE:
      reportNumber = 128
      break
    case ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL_SIMPLE:
      reportNumber = 126
      break
    case ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL:
      reportNumber = 125
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNTS_NEW_VERSION_REPORT:
      reportNumber = 132
      break
    case ReportType.DRIVER_CONTRACTS_FROM_PERIOD:
      reportNumber = 131
      break
    case ReportType.TIMESHEET_REWARD_FOR_DRIVERS:
      reportNumber = 124
      break
    case ReportType.DRIVER_COMPLETE_SETTLEMENT:
      reportNumber = 123
      break
  }

  return reportNumber
}

export const getReportNameByType = (type: ReportType) => {
  let reportName = ''

  switch (type) {
    case ReportType.DRIVER_ACTIVITIES:
      reportName = 'printout.driverActivities'
      break
    case ReportType.DRIVER_DAILY_ACTIVITIES:
      reportName = 'printout.driverDailyActivities'
      break
    case ReportType.DRIVER_WEEKLY_ACTIVITIES:
      reportName = 'printout.driverWeeklyActivities'
      break
    case ReportType.VIOLATIONS:
      reportName = 'printout.violations'
      break
    case ReportType.GROUPED_VIOLATIONS:
      reportName = 'printout.groupedViolations'
      break
    case ReportType.TIMESHEET:
      reportName = 'printout.timesheet'
      break
    case ReportType.TIMESHEET_AMOUNTS_REPORT:
      reportName = 'printout.timesheetAmountsReport'
      break
    case ReportType.TRIP_SUMMARY:
      reportName = 'printout.tripSummary'
      break
    case ReportType.TRIP_DETAILS:
      reportName = 'printout.tripDetails'
      break
    case ReportType.BASIC_TRIP_PRINT:
      reportName = 'printout.tripBasics'
      break
    case ReportType.GROUPED_TRIP_BASICS:
      reportName = 'printout.groupedTripBasics'
      break
    case ReportType.TRIP_GENERAL_STATEMENT:
      reportName = 'printout.tripGeneralStatement'
      break
    case ReportType.TIMESHEET_LUMPSUM_SETTLEMENT:
      reportName = 'printout.timesheetLumpSumSettlement'
      break
    case ReportType.TIMESHEET_LUMPSUM_SETTLEMENT_SUMMARY:
      reportName = 'printout.timesheetLumpsumSettlementSummary'
      break
    case ReportType.TIMESHEET_LUMPSUM_UTILIZATION:
      reportName = 'printout.timesheetLumpSumUtilization'
      break
    case ReportType.DRIVER_AVAILABLE_TIME:
      reportName = 'printout.driverAvailableTime'
      break
    case ReportType.CARD_READING_DEADLINE:
      reportName = 'printout.cardReadingDeadline'
      break
    case ReportType.DRIVER_INSTRUCTION:
      reportName = 'printout.driverInstruction'
      break
    case ReportType.TIMESHEET_EMPTY_DAYS:
      reportName = 'printout.timesheetEmptyDays'
      break
    case ReportType.TIMESHEET_SUMMARY:
      reportName = 'printout.timesheetSummary'
      break
    case ReportType.DOCUMENT_VALIDITY_DEADLINE:
      reportName = 'printout.documentValidityDeadline'
      break
    case ReportType.DRIVER_FAULTS_AND_EVENTS:
      reportName = 'printout.driverFaultsAndEvent'
      break
    case ReportType.DRIVER_CARD_APPLICATION:
      reportName = 'printout.driverCardApplication'
      break
    case ReportType.OUTGOING_CHECKLIST:
      reportName = 'printout.outgoingChecklist'
      break
    case ReportType.BUSINESS_TRIP_COMMAND:
      reportName = 'printout.businessTripCommand'
      break
    case ReportType.TRIP_DEPOSIT_REQUEST:
      reportName = 'printout.tripDepositRequest'
      break
    case ReportType.DRIVER_DATA_COMPLETNESS:
      reportName = 'printout.driverDataCompletness'
      break
    case ReportType.DRIVER_ATTESTATION_REPORT:
      reportName = 'printout.driverAttestationReport'
      break
    case ReportType.TIMESHEET_APPLICATION_FOR_OVERHOURS_FOR_DRIVERS:
      reportName = 'printout.timesheetApplicationForOverhoursForDrivers'
      break
    case ReportType.TIMESHEET_PERIOD_SUMMARY:
      reportName = 'printout.timesheetPeriodSummary'
      break
    case ReportType.TIMESHEET_WORKING_HOURS:
      reportName = 'printout.timesheetWorkingHoursReport'
      break
    case ReportType.DRIVER_FREE_DAYS:
      reportName = 'printout.driverFreeDays'
      break
    case ReportType.TIMESHEET_OVERHOURS_SUMMARY:
      reportName = 'printout.timesheetOverhoursSummary'
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNT_SUMMARY:
      reportName = 'printout.timesheetForeignAmountSummary'
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNTS_NEW_VERSION_REPORT:
      reportName = 'printout.timesheetForeignAmountsNewVersionReport'
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNTS_REPORT:
      reportName = 'printout.timesheetForeignAmountsReport'
      break
    case ReportType.TIMESHEET_FOREIGN_AMOUNTS_FOR_DRIVER_REPORT:
      reportName = 'printout.timesheetForeignAmountsForDriverReport'
      break
    case ReportType.DRIVER_DAY_DETAILS:
      reportName = 'printout.driverDayDetails'
      break
    case ReportType.DRIVER_DAY_DETAILS_WITH_SIGNATURE_REPORT:
      reportName = 'printout.driverDayDetailsWithSignatureReport'
      break
    case ReportType.TRIP_FOREIGN_COUNTRY:
      reportName = 'printout.tripForeignCountry'
      break
    case ReportType.LOCALIZATION:
      reportName = 'printout.localization'
      break
    case ReportType.TIMESHEET_TIME_SUMMARY:
      reportName = 'printout.timesheetTimeSummary'
      break
    case ReportType.DRIVER_CALENDAR:
      reportName = 'printout.multipleDriverYearlyActivities'
      break
    case ReportType.WEEKLY_RESTS:
      reportName = 'printout.weeklyRests'
      break
    case ReportType.WEEKLY_RESTS_WITH_LOCATION:
      reportName = 'printout.weeklyRestsWithLocation'
      break
    case ReportType.SPECIFIC_BUSINESS_TRIP_COMMAND:
      reportName = 'printout.businessTripCommand'
      break
    case ReportType.TRIP_INVOICES:
      reportName = 'printout.tripInvoices'
      break
    case ReportType.DRIVER_CARD_READING:
      reportName = 'printout.driverCardReading'
      break
    case ReportType.TIMESHEET_APPLICATION_FOR_LEAVE_FOR_DRIVERS:
      reportName = 'printout.timesheetApplicationForLeave'
      break
    case ReportType.DRIVER_PERIOD_DISTANCE:
      reportName = 'printout.driverPeriodDistance'
      break
    case ReportType.COMPANY_REPUTATION_INDEX:
      reportName = 'printout.companyReputationIndex'
      break
    case ReportType.TIMESHEET_YEAR_SUMMARY:
      reportName = 'printout.timesheetYearSummary'
      break
    case ReportType.VEHICLE_ACTIVITIES:
      reportName = 'printout.vehicleActivities'
      break
    case ReportType.VEHICLE_CALIBRATION_DEADLINE:
      reportName = 'printout.vehicleCalibrationDeadline'
      break
    case ReportType.VEHICLE_CARD_READING_AND_CALIBRATION_DEADLINE:
      reportName = 'printout.vehicleCardReadingAndCalibrationDeadline'
      break
    case ReportType.VEHICLE_CARD_READING_DEADLINE:
      reportName = 'printout.vehicleCardReadingDeadline'
      break
    case ReportType.VEHICLE_DATA_COMPLETNESS:
      reportName = 'printout.vehicleDataCompletness'
      break
    case ReportType.VEHICLE_DAY_DETAILS:
      reportName = 'printout.vehicleDayDetails'
      break
    case ReportType.VEHICLE_FAULTS_AND_EVENTS:
      reportName = 'printout.vehicleFaultsAndEvents'
      break
    case ReportType.VEHICLE_CALENDAR:
      reportName = 'printout.vehicleCalendar'
      break
    case ReportType.DRIVER_ACTIVITY_SUMMARY:
      reportName = 'printout.driverActivitySummary'
      break
    case ReportType.MANAGER_REPORT_1:
      reportName = 'printout.managerReport1'
      break
    case ReportType.MANAGER_REPORT_2:
      reportName = 'printout.managerReport2'
      break
    case ReportType.MANAGER_REPORT_3:
      reportName = 'printout.managerReport3'
      break
    case ReportType.DATA_ACCESS_EVENTS:
      reportName = 'printout.dataAccessEvents'
      break
    case ReportType.DRIVERS_VIOLATIONS:
      reportName = 'printout.violations'
      break
    case ReportType.FOREIGN_COUNTRY_SERVICE_DECLARATIONS_DEADLINES:
      reportName = 'printout.foreignDeclarations'
      break
    case ReportType.FOREIGN_COUNTRY_DECLARATIONS_DEADLINES:
      reportName = 'printout.foreignDeclarations'
      break
    case ReportType.ACTIVITY_CHANGE_CONFIRMATION_REPORT:
      reportName = 'printout.activityChangeConfirmationPopup'
      break
    case ReportType.VEHICLES_LIST:
      reportName = 'printout.vehiclesList'
      break
    case ReportType.DRIVERS_LIST:
      reportName = 'printout.driversList'
      break
    case ReportType.TIMESHEET_DETAILED_WAGE_REPORT:
      reportName = 'printout.timesheetDetailedWageReport'
      break
    case ReportType.TIMESHEET_LEAVES_CALCULATION:
      reportName = 'printout.print-vacation-rate-calculation'
      break
    case ReportType.TIMESHEET_LEAVE_EQUIVALENT_CALCULATION:
      reportName = 'printout.print-leave-equivalent-calculation'
      break
    case ReportType.DRIVER_APPLICATIONS:
      reportName = 'printout.driverApplications'
      break
    case ReportType.ALL_ALERTS:
      reportName = 'printout.allAlerts'
      break
    case ReportType.SELECTED_ALERTS:
      reportName = 'printout.selectedAlerts'
      break
    case ReportType.VEHICLE_DAILY_ACTIVITIES:
      reportName = 'printout.vehicleDailyActivities'
      break
    case ReportType.VEHICLE_WEEKLY_ACTIVITIES:
      reportName = 'printout.vehicleWeeklyActivities'
      break
    case ReportType.MOBILITY_PACKAGE_PAYROL_REPORT:
      reportName = 'printout.mobilityPackagePayrollReport'
      break
    case ReportType.REWARDS_TO_ACCEPT_REPORT:
      reportName = 'printout.rewardsToAcceptReport'
      break
    case ReportType.SELECTED_TIMESHEET_MOBILITY_PACKAGE_PAYROLL_REPORT:
      reportName = 'printout.selectedMobilityPackagePayrollReport'
      break
    case ReportType.SELECTED_REWARDS_TO_ACCEPT_REPORT:
      reportName = 'printout.selectedRewardsToAcceptReport'
      break
    case ReportType.TIMESHEET_SCHEDULE:
      reportName = 'printout.timesheetSchedule'
      break
    case ReportType.FOREIGN_ALLOWANCES:
      reportName = 'printout.foreignAllowances'
      break
    case ReportType.TRIP_COSTS:
      reportName = 'printout.tripCosts'
      break
    case ReportType.TIMESHEET_PAYMENT_DETAILS:
      reportName = 'printout.timesheetPaymentDetails'
      break
    case ReportType.TIMESHEET_PAYMENT_DETAILS_CSV:
      reportName = 'printout.timesheetPaymentDetailsCsv'
      break
    case ReportType.STATEMENT_ON_EMPLOYEES_COUNT:
      reportName = 'printout.statementOnEmployeesCount'
      break
    case ReportType.DRIVER_YEAR_GROSS_AMOUNTS:
      reportName = 'printout.driverYearGrossAmounts'
      break
    case ReportType.DECLARATION_NOT_RETURN_TO_PLACE_OF_RESIDENCE:
      reportName = 'printout.declarationNotReturnToPlaceOfResidence'
      break
    case ReportType.VIRTUAL_DISPLACEMENT:
      reportName = 'printout.virtualDisplacement'
      break
    case ReportType.TIMESHEET_CALCULATION_AUDIT:
      reportName = 'printout.timesheetCalculationAudit'
      break
    case ReportType.DRIVER_CONTRACT_SUMMARY:
      reportName = 'printout.driverContractSummary'
      break
    case ReportType.DRIVER_CONTRACT_ANNEX:
      reportName = 'printout.driverContractAnnex'
      break
    case ReportType.DRIVER_CONTRACT_ADAPTIVE:
      reportName = 'printout.driverContractAdaptive'
      break
    case ReportType.NIGHT_WORK_DUTY_DELEGATIONS_REPORT:
      reportName = 'printout.nightWorkDutyDelegationsReport'
      break
    case ReportType.DRIVER_CARDS:
      reportName = 'printout.driverCards'
      break
    case ReportType.TIMESHEET_LEAVE_DAYS_REPORT:
      reportName = 'printout.timesheetLeaveDaysReport'
      break
    case ReportType.TIMESHEET_WORK_COSTS:
      reportName = 'printout.timesheetWorkCosts'
      break
    case ReportType.TIMESHEET_PAYMENT_REPORT:
      reportName = 'printout.timesheetPaymentReport'
      break
    case ReportType.DRIVER_WORKING_DAYS:
      reportName = 'printout.driverWorkingDays'
      break
    case ReportType.VEHICLE_CARD_INSERTION_WITHDRAWAL:
      reportName = 'printout.vehicleCardInsertionWithdrawal'
      break
    case ReportType.FREE_DAYS_SUMMARY_SERVICE_REPORT:
      reportName = 'printout.freeDaysSummaryServiceReport'
      break
    case ReportType.MINIMAL_PAYMENT_COUNTRY_HOURS_SERVICE_REPORT:
      reportName = 'printout.minimalPaymentCountryHoursServiceReport'
      break
    case ReportType.MINIMAL_PAYMENT_COUNTRY_AMOUNTS_SERVICE_REPORT:
      reportName = 'printout.minimalPaymentCountryAmountsServiceReport'
      break
    case ReportType.TIMESHEET_HOURS_SERVICE_REPORT:
      reportName = 'printout.timesheetHoursServiceReport'
      break
    case ReportType.FOREIGN_TRIPS_SERVICE_REPORT:
      reportName = 'printout.foreignTripsServiceReport'
      break
    case ReportType.CARD_READING_DEADLINE_SERVICE:
      reportName = 'printout.cardReadingDeadlineService'
      break
    case ReportType.DRIVER_ACTIVENESS:
      reportName = 'printout.driverActiveness'
      break
    case ReportType.VEHICLE_TACHO_DETAILS:
      reportName = 'printout.vehicleTachoDetails'
      break
    case ReportType.VEHICLE_TACHOGRAPH_DEADLINE:
      reportName = 'printout.vehicleTachographDeadline'
      break
    case ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL_SIMPLE:
      reportName = 'printout.driverCardInsertionWithdrawalSimple'
      break
    case ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL:
      reportName = 'printout.driverCardInsertionWithdrawal'
      break
    case ReportType.DRIVER_CONTRACTS_FROM_PERIOD:
      reportName = 'printout.driverContractsFromPeriod'
      break
    case ReportType.TIMESHEET_REWARD_FOR_DRIVERS:
      reportName = 'printout.timesheetRewardForDrivers'
      break
    case ReportType.DRIVER_COMPLETE_SETTLEMENT:
      reportName = 'printout.driverCompleteSettlement'
      break
  }

  return reportName
}
